export default [{
  label: 'Texte',
  type: 'text',
}, {
  label: 'Choix entre plusieurs propositions',
  type: 'list',
}, {
  label: 'Lieu de l\'activité',
  type: 'location',
  unique: true,
}];



// WEBPACK FOOTER //
// ./src/components/Admin/ActivitiesManagement/ActivityEdit/AddControl/types.js